export default __webpack_public_path__ + "static/media/google.f086ab55.png";